<template>
  <div class="">
    <Head :info="deviceInfo"></Head>
    <div class="ml-1">
      <div class="rowCC heightpx-60">
        <div class="font-sizepx16">监测频率</div>
        <div class="m-2">
          <el-input v-model="keyword" placeholder="请输入">
            <template #append>秒</template>
          </el-input>
        </div>
        <div class="">
          <el-button type="primary" @click="update">更新频率</el-button>
        </div>
        <!-- <el-select
          class="ml-2"
          v-model="seleteValue"
          placeholder="请选择"
          @change="seleteChange"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-date-picker
          class="ml-2"
          v-model="time"
          @change="change"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择日期"
        >
        </el-date-picker>
        <!-- <el-date-picker
          v-model="time"
          @change="change"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择日期"
        >
        </el-date-picker> -->
      </div>
      <div class="rowCC">
        <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(i, index) in tabList"
            :key="index"
            :label="i.name"
            :name="i.type"
          >
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="loading"
              element-loading-text="拼命加载中"
            >
              <template v-for="(j, n) in columnList">
                <el-table-column
                  v-if="j.slot"
                  :prop="j.prop"
                  :label="j.name"
                  :width="j.width ? j.width : tbWidth"
                >
                  <template slot-scope="{ row }">
                    <span>
                      {{ row.spectrumWarning ? row.spectrumWarning : "正常" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-else
                  :prop="j.prop"
                  :label="j.name"
                  :width="j.width ? j.width : tbWidth"
                >
                  <template slot-scope="{ row }">
                    <span
                      @click="infoView(j.prop, row)"
                      :class="
                        j.prop == 'ObserveTime' ? ['colorInfo', 'pointer'] : ''
                      "
                      >{{
                        j.property
                          ? row[j.property][j.prop]
                            ? row[j.property][j.prop]
                            : "-"
                          : row[j.prop]
                      }}</span
                    >
                  </template>
                </el-table-column>
              </template>
            </el-table>
            <el-pagination
              v-if="tableData.length"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 40, 60, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs> -->
        <div style="width: 95%">
          <el-table :data="tableData" style="width: 100%" border stripe>
            <el-table-column
              label="水质动态"
              align="center"
              width="150"
              class-name="tableColumn"
              fixed
            >
              <el-table-column prop="city" label="采集时间" width="200">
                <template slot-scope="{ row }">
                  <span
                    class="pointer"
                    @click="infoView(row)"
                    style="color: #44bbfc"
                    >{{ row.ObserveTime }}</span
                  >
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="水质指标"
              class-name="tableColumn"
            >
              <el-table-column
                v-for="(i, index) in columnList"
                :label="i.Caption"
                width="80"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.Data[i.Name] }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="province" label="CODmn" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.Data.CODmn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="city" label="COD" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.Data.COD }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="氨氮" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.Data.NH3 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="zip" label="总磷" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.Data.TP }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="zip" label="总氮" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.Data.TP }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="zip" label="浊度" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.Data.TUB }}</span>
              </template>
            </el-table-column> -->
            </el-table-column>
            <el-table-column
              label="站房参数"
              align="center"
              width="80"
              class-name="tableColumn"
            >
              <el-table-column prop="city" label="温度" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.Temp }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="湿度" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.Humidity }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="zip" label="流速" width="80">
                <template slot-scope="{ row }">
                  <span
                    :style="{
                      color: row.Machine.flow < 0.001 ? 'red' : '',
                    }"
                    >{{ row.Machine.flow }}</span
                  >
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column
              label="电源系统"
              align="center"
              class-name="tableColumn"
            >
              <el-table-column prop="province" label="电池电压" width="80">
                <template slot-scope="{ row }">
                  <span
                    :style="{ color: row.Machine.batteryV < 10 ? 'red' : '' }"
                    >{{ row.Machine.batteryV }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="city" label="充电电流" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.chargeCurrent }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="充电电压" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.panelV }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="zip" label="放电电流" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.hargeCurrent }}</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="zip" label="电池温度" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.batteryTemp }}</span>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column
              label="通讯系统"
              align="center"
              class-name="tableColumn"
            >
              <el-table-column prop="province" label="光谱信号" width="100">
                <template slot-scope="{ row }">
                  <span :class="row.spectrumWarning ? 'colorR' : ''">{{
                    row.spectrumWarning ? row.spectrumWarning : "正常"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="city" label="PH信号" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Data.PH }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="溶氧信号" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Data.DO }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="清洁系统"
              align="center"
              class-name="tableColumn"
            >
              <el-table-column prop="city" label="气罐压力" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.gasholderPressure }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="最大压力" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.gasholderPressure }}</span>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column
              label="光学探头"
              align="center"
              class-name="tableColumn"
            >
              <el-table-column prop="province" label="温度" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.tantouTemp }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="city" label="湿度" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.Machine.tantouHumidity }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-1"
            v-if="tableData.length"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 40, 60, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from "@/components/Head";
import * as api from "@/api/home";
import { isMobile } from "@/utils/utils";
export default {
  components: {
    Head,
  },
  name: "Dashboard",
  data() {
    return {
      total: 0,
      pageSize: 1,
      pageNum: 10,
      currentPage: 1,
      keyword: "",
      activeName: "station",
      tabList: [
        { name: "站房参数", type: "station" },
        { name: "水质指标", type: "water" },
        { name: "清洁系统", type: "clean" },
        { name: "光学探头", type: "opticalProbe" },
        { name: "电源系统", type: "powerSystem" },
        { name: "通讯系统", type: "communicate" },
        // { name: "物联网卡", type: "iot" },
      ],
      tableData: [],
      columnList: [],
      list: {
        station: [
          { name: "时间", prop: "ObserveTime", width: "100" },
          { name: "温度", prop: "Temp", property: "Machine" },
          { name: "湿度", prop: "Humidity", property: "Machine" },
          { name: "流速", prop: "flow", property: "Machine" },
        ],
        water: [
          { name: "时间", prop: "ObserveTime", width: "100" },
          { name: "CODmn", prop: "CODmn", property: "Data" },
          { name: "COD", prop: "COD", property: "Data" },
          { name: "氨氮", prop: "NH3", property: "Data" },
          { name: "总磷", prop: "TP", property: "Data" },
          { name: "总氮", prop: "TN", property: "Data" },
          { name: "浊度", prop: "TUB", property: "Data" },
        ],
        clean: [
          { name: "时间", prop: "ObserveTime", width: "100" },
          { name: "气罐压力", prop: "gasholderPressure", property: "Machine" },
          { name: "最大压力", prop: "gasholderPressure", property: "Machine" },
        ],
        opticalProbe: [
          { name: "时间", prop: "ObserveTime", width: "100" },
          { name: "温度", prop: "tantouTemp", property: "Machine" },
          { name: "湿度", prop: "tantouHumidity", property: "Machine" },
        ],

        powerSystem: [
          { name: "时间", prop: "ObserveTime", width: "100" },
          { name: "电池电压", prop: "batteryV", property: "Machine" },
          { name: "充电电流", prop: "chargeCurrent", property: "Machine" },
          { name: "充电电压", prop: "panelV", property: "Machine" },
          // { name: "放电电流", prop: "hargeCurrent", property: "Machine" },
          { name: "电池温度", prop: "batteryTemp", property: "Machine" },
        ],
        communicate: [
          { name: "时间", prop: "ObserveTime", width: "100" },
          { name: "光谱信号", prop: "spectrumWarning", slot: true },
          { name: "PH信号", prop: "PH", property: "Data" },
          { name: "溶氧信号", prop: "DO", property: "Data" },
        ],
        // iot: [{ name: "时间" }, { name: "卡号" }, { name: "剩余流量" }],
      },
      loading: false,
      deviceInfo: {},
      sn: "", //设备编号
      time: "", //
      options: [
        {
          value: "0",
          label: "天",
        },
        {
          value: "1",
          label: "小时",
        },
      ],
      seleteValue: "",
    };
  },
  methods: {
    handleClick({ name }) {
      this.tableData = [];
      this.activeName = name;
      this.columnList = this.list[name];
      this.total = 0;
      this.pageNum = 10;
      this.pageSize = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageSize = val;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let param = {
          limit: this.pageNum,
          skip: (this.pageSize - 1) * this.pageNum,
          SN: this.sn,
          date: this.time,
        };
        let { data } = await api.list(param);
        this.loading = false;
        this.total = data.total;
        this.tableData = data.rows;
      } catch (error) {
        this.loading = false;
      }
    },
    // 获取设备信息
    async getDeviceInfo() {
      try {
        let param = {
          SN: this.sn,
        };
        let { data } = await api.getInfo(param);
        this.keyword = data.sleep;
        this.deviceInfo = data;
      } catch (error) {}
    },
    // 更新
    async update() {
      try {
        let param = {
          SN: this.sn,
          sleep: this.keyword,
        };
        await api.refreshRate(param);
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } catch (error) {
        this.$message({
          message: "操作失败",
          type: "error",
        });
      }
    },
    // 视图
    infoView(row) {
      window.sessionStorage.setItem("date", this.time);
      console.log(row, "---res");
      this.$router.push({
        name: "info",
        query: {
          deviceInfo: JSON.stringify(this.deviceInfo),
          detail: JSON.stringify(row),
          columnList: JSON.stringify(this.columnList),
        },
      });
    },
    change(e) {
      this.time = e;
      this.getList();
    },
    // 选择器改变
    seleteChange(val) {
      this.time = "";
    },
    // 获取当前指标、
    async getElements() {
      try {
        let { data } = await api.getElements({ SN: this.sn });
        data.sort(function (a, b) {
          return a.order - b.order;
        });
        this.columnList = data;
      } catch (error) {}
    },
  },
  computed: {
    tbWidth() {
      // console.log(isMobile());
      return isMobile() ? "50" : "200";
    },
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.type) {
          //需要监听的参数
          // this.type = this.$route.query.type
        }
      },
    },
  },
  mounted() {
    this.time = window.sessionStorage.getItem("date");
    let url = location.href.split("=");
    this.sn = url[1];
    // this.columnList = this.list.station;
    this.getList();
    this.getDeviceInfo();
    this.getElements();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pointer {
  cursor: pointer;
}
.colorR {
  color: red;
}
/deep/ .tableColumn {
  color: #1684fc;
  border: 1px solid #1684fc;
  background: #fff !important;
  margin-bottom: 10px;
}
/deep/ .el-table thead.is-group th.el-table__cell {
  background: #edf1fe;
  color: #4d79f3;
}
</style>
